import { styled } from "sharedUI/styles";
import { css } from "styled-components";

export const Input = styled.input`
    /* Min will force override the browsers default min-width which can cause issues with overflow in certain browsers. */
    min-width: 0px;
    width: 100%;
    padding: 0 12px;
    align-self: stretch;
    color: ${p => p.theme.fgColorDark};
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 13px;
    font-weight: 300;
    background-color: ${p => p.theme.formControlBg};
    transition: background-color ${p => p.theme.transitionBase};
    &:hover,
    &:focus {
        background-color: ${p => p.theme.formControlBgHover};
    }

    ::placeholder {
        color: ${p => p.theme.fgColorLight};
    }
`;

export const TextArea = styled.textarea`
    ::placeholder {
        color: ${p => p.theme.fgColorLight};
    }
`;

interface InputWrapperProps {
    highlightWarning?: boolean;
    lightBorder?: boolean;
    focusBorder?: boolean;
    disabled?: boolean;
    hasPostfix: boolean;
    tallerVariation?: boolean;
}

export const InputWrapper = styled.div<InputWrapperProps>`
    align-items: center;
    height: ${p => (p.tallerVariation ? 40 : 32)}px;
    border-radius: 8px;
    display: flex;

    input {
        border: 1px solid ${p => (p.highlightWarning ? p.theme.destroyColor : "transparent")};
        border-radius: ${p => (p.hasPostfix ? "8px 0px 0px 8px" : "8px")};
        &:focus {
            border: 1px solid ${p => (p.focusBorder ? p.theme.b400 : "transparent")};
            background-color: ${p => (p.focusBorder ? p.theme.formControlBg : p.theme.formControlBgHover)};
        }
    }

    ${p =>
        p.disabled === true &&
        css`
            background-color: ${p.theme.bgColorAlt};
            > input,
            > input:hover,
            > input:focus {
                color: ${p.theme.formControlBg};
            }
        `}
`;

export const Postfix = styled.div`
    display: flex;
    align-items: center;
    font-size: 12px;
    color: ${p => p.theme.fgColorMedium};
    background-color: ${p => p.theme.formControlBg};
    height: 100%;
    border-radius: 0px 8px 8px 0px;
`;

export const Warning = styled.div`
    font-size: 11px;
    color: ${p => p.theme.destroyColor};
`;

export const BylineWrapper = styled.div`
    margin-top: 4px;
`;

export const ClearWrapper = styled.div`
    color: ${p => p.theme.fgColorDark};
    cursor: pointer;

    padding-right: 8px;
`;
